import { Action } from "redux"

import { pumaAPI } from "./api"
import { ReceiveError } from "../components/auth/actions"
import { ReceiveNothing } from "./api/base"

export const getLogo = (): Promise<string> => pumaAPI.getText("resources/logo")

export const checkDatabaseVersion = (): Promise<Action | ReceiveError> =>
    pumaAPI.getJSON("checkdatabaseversion", null, ReceiveNothing)

export const checkMaintenance = (): Promise<Action | ReceiveError> =>
    pumaAPI.getJSON("checkmaintenance", null, ReceiveNothing)

export const login = (
    username: string,
    password: string,
    remember: boolean,
): Promise<Action | ReceiveError> =>
    pumaAPI.postJSON("session/start", {
        Login: username,
        Password: password,
        DontRemember: !remember,
    })

export const logout = (): Promise<void> =>
    pumaAPI.postJSON("session/end", null, {
        accept: "*/*",
        handler: (response: Response) => {
            if (response.ok || response.status === 401) {
                return
            }
            throw response
        },
    })

export const restorePassword = (
    email: string,
): Promise<Action | ReceiveError> =>
    pumaAPI.postJSON("actions/restorepassword", { email })
